import { useEffect } from "react";

export const useTab = (tabHandler: () => void, tabShiftHandler: () => void) => {
  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Tab") {
        if (event.shiftKey) {
          //shift+tab pressed
          tabShiftHandler();
        } else {
          //only tab pressed
          tabHandler();
        }
      }
    };

    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [tabHandler, tabShiftHandler]);
};
